import { render, staticRenderFns } from "./ViewCollegeModal.vue?vue&type=template&id=0ca9761f&scoped=true&"
import script from "./ViewCollegeModal.vue?vue&type=script&lang=js&"
export * from "./ViewCollegeModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewCollegeModal.vue?vue&type=style&index=0&id=0ca9761f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9761f",
  null
  
)

export default component.exports